import React from 'react'
import css from './style.scss'
import moment from 'moment'

export default (props)=>{
  let date=moment(props.date)
  return (
    <div className={css.date}>
      <h3><b>{date.format('DD MMM YYYY')}</b> - {date.format('HH:mm')}</h3>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/sidebar/date.js